import * as React from 'react'
import './Switch.css'

import classNames from 'classnames'

import Steps from './Steps'
import Node from './Node'
import WithContextMenu from './WithContextMenu'
import * as actions from '../actions'

import { Cursor, CursorV } from '../lib/Cursor'
import { evaluateNode } from '../model/evaluate'
import { NetworkUser } from 'golgi'
import StepProps from './StepProps'
import * as Model from '../types/document'


class Switch extends React.Component<StepProps<Model.Switch>> {
  render() {
    return <NetworkUser debugName="Switch" props={this.props} state={this.state} render={() => {
      const {stepC: switchC, stepsC, blockC, stack} = this.props

      const casesC = switchC.select('cases')

      const outputNodeC = switchC.select('output')
      const outputNodeId = outputNodeC.select('id').get()
      const caseTaken = evaluateNode(outputNodeId, stack).caseTaken

      const toReturn = <div className="Switch">
        <WithContextMenu menuMaker={() => [{
          type: 'heading',
          heading: "SWITCH"
        }, {
          type: 'contents',
          contents: "Delete switch",
          onClick: () => actions.act(() => actions.deleteStepFromSteps(switchC))
        }]}>
          <div className="Switch-cases">
            {casesC.fetch().call(CursorV.elems).map((caseC, i) => {
              const conditionC = CursorV.unwrapMaybe(caseC.select('condition'))
              return <React.Fragment key={i}>
                { conditionC &&
                  <React.Fragment>  
                    <div className={classNames("Switch-case-condition")}>
                        <div className="Switch-heading Switch-heading-if">if</div>
                    </div>
                    <div className={classNames("Switch-case-body")}>
                      <Steps stepsC={conditionC.unfetch()} blockC={blockC} stack={stack} />
                    </div>
                  </React.Fragment>
                }
                <div className={classNames("Switch-case-condition", {"Switch-case-taken": i === caseTaken})}>
                  { conditionC
                  ? <div className="Switch-heading Switch-heading-then">then</div>
                  : <span className="Switch-heading">else</span>
                  }
                </div>
                <div className={classNames("Switch-case-body", {"Switch-case-taken": i === caseTaken})}>
                  <Steps stepsC={caseC.select('steps').unfetch()} blockC={blockC} stack={stack} />
                  <div className="Switch-case-body-cover" />
                </div>
              </React.Fragment>
            })}
            <div className="Switch-case-condition">
              <div className="Switch-heading">output</div>
            </div>
            <div className="Switch-case-body">
              <Node nodeId={outputNodeId} blockC={blockC} stack={stack} />
            </div>
          </div>
          {/* <div className="Switch-result"
               style={{width: "fit-content", float: "right", padding: "0 20px", display: "flex", alignItems: "center"}}>
            <span className="Switch-heading">output: </span>
            <Node nodeId={outputNodeId} blockC={blockC} stack={stack} />
          </div> */}
        </WithContextMenu>
      </div>
      // console.groupEnd()
      return toReturn
    }} />
  }
}

export default Switch;



// WEBPACK FOOTER //
// ./src/view/Switch.tsx